module.exports = __webpack_public_path__ + "media/images/banks/vn-vietinbank-d268e29db3f1162540c0b9d69e7eef12.png";